import { t } from 'i18next';
import { SingularStationArea } from '@thive/fddm-types';

import { ToolId } from '@/modules/toolbar/types';

export const getLoadHandlingType = (tool: ToolId): SingularStationArea['loadHandlingType'] => {
  switch (tool) {
    case 'delivery':
      return 'DELIVERY';
    case 'process':
      return 'OFF_VEHICLE_PROCESSING';
    case 'storage':
      return 'STORAGE';
    case 'intake':
    default:
      return 'INTAKE';
  }
};

const LOAD_HANDLING_TYPE_LABEL_KEYS: Record<SingularStationArea['loadHandlingType'], string> = {
  INTAKE: 'interface:layers.intake',
  DELIVERY: 'interface:layers.delivery',
  STORAGE: 'interface:layers.storage',
  OFF_VEHICLE_PROCESSING: 'interface:layers.process',
  ON_VEHICLE_PROCESSING: 'interface:layers.process',
  INTAKE_AND_DELIVERY: 'interface:layers.intake',
};

/**
 * Returns the user-facing label for a load handling type, reusing the
 * existing layer translations (e.g. `'INTAKE'` -> `"Intake"`,
 * `'OFF_VEHICLE_PROCESSING'` -> `"Process"`).
 */
export const getLoadHandlingTypeLabel = (type: SingularStationArea['loadHandlingType']): string =>
  t(LOAD_HANDLING_TYPE_LABEL_KEYS[type]);

/**
 * Formats a list of load handling types as a human readable list,
 * e.g. `['INTAKE', 'STORAGE', 'OFF_VEHICLE_PROCESSING']` -> `"Intake,
 * Storage or Process"`. Duplicate labels (multiple raw types sharing a
 * label, e.g. `OFF_VEHICLE_PROCESSING` and `ON_VEHICLE_PROCESSING` are
 * both `"Process"`) are removed.
 */
export const formatLoadHandlingTypes = (
  types: SingularStationArea['loadHandlingType'][],
): string => {
  const labels = Array.from(new Set(types.map(getLoadHandlingTypeLabel)));
  if (labels.length === 0) return '';
  if (labels.length === 1) return labels[0];
  const head = labels.slice(0, -1).join(', ');
  const tail = labels[labels.length - 1];
  return `${head} or ${tail}`;
};
